module.exports = __webpack_public_path__ + "static/Salesforce-9f0c75c59590829b795f4dc1e05c157a.mp4";